const blockingEmails = [
  'none@none.com',
  'noemail@noemail.com',
  'noemail@gmail.com',
  'noemail@email.com',
  'none@noemail.COM',
  'none@gmail.com',
  'none@yahoo.com',
  'no@no.com',
  'no@email.com',
  'noemail@yahoo.com',
  'test@test.com',
  'na@ba.com',
  'noname@gmail.com',
  'no@gmail.com',
  'noemail@mail.com',
  'test@email.com',
  'unknown@yahoo.com',
  'non@non.com',
  'noemail@noemail.COM',
  'none@email.com',
  'noname@email.com',
  'noemail@no.com',
  'non@none.com',
  'email@email.com',
  'nomail@gmail.com',
  'noemail@gimail.com',
  'noemail@aol.com',
  'na@gmail.com',
  'noemail@gmai.com',
  'Noemail@noemai.com',
  'none@aol.com',
];

export default blockingEmails;



// WEBPACK FOOTER //
// ./src/utils/blockedEmails.js